import { FileType } from '@treetop/shared/model';

/**
 * Opens a file dialog and calls the onFileSelected callback with the selected file.
 * @param allowedExtensions A list of FileTypes that are allowed to be selected.
 * @param onFileSelected A callback that is called with the selected file.
 */
export const selectFile = (allowedExtensions: FileType[], onFileSelected: (file: File) => void): void => {
  const input = document.createElement('input');
  input.type = 'file';
  input.accept = allowedExtensions.map((ext) => `.${ext}`).join(',');

  input.onchange = (event: Event) => {
    const target = event.target as HTMLInputElement;
    const file = target.files?.item(0);

    if (file) {
      onFileSelected(file);
    }
  };

  input.click();
};
